import React from 'react'
import { Link } from 'react-router-dom'

function About() {
  return (
    <div className="p-4 sm:ml-56 mt-4">
      <div className="container mx-auto m-10">
        <div className="rounded-lg bg-gray-50 dark:bg-gray-400 w-full flex items-center mb-7 lg:mb-12 xl:mb-16">
          <div className="p-4 md:p-9">
            <header className="text-base mb-6 lg:py-[3.5px] !leading-none font-medium relative pl-4 after:absolute after:w-[3px] md:after:w-[4px] after:h-[110%] after:top-[-5%] after:bg-[#5AC4D1] after:left-0 after:rounded-md">
              <span>About gameszone</span>
            </header>
            <div className="2xl:pr-36 flex flex-col gap-4 sm:gap-9 lg:gap-10">

              <section>
                <h1 className="text-xl lg:text-2xl mb-6 font-bold capitalize">Play Free Games Online Without Downloading</h1>
                <p className="leading-8 font-medium capitalize">
                  gameszone is the perfect place for you to instantly play any game, anytime, anywhere—desktop, mobile, or tablet. Enjoy our amazing collection without downloading.
                </p>
              </section>

              <section>
                <h2 className="text-xl lg:text-2xl mb-6 font-bold capitalize">Benefits of Playing Games Online</h2>
                <p className="leading-8 font-medium capitalize">Playing games is not only a leisure activity but has many benefits.</p>
                <div className="px-10">
                  <ul className="list-disc text-base font-medium capitalize leading-8">
                    <li>Relaxes your mind</li>
                    <li>Brings peace</li>
                    <li>Improves creativity</li>
                    <li>Improves critical thinking</li>
                    <li>Improves responsiveness</li>
                    <li>Releases dopamine or happy hormones to keep you calm</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl lg:text-2xl mb-6 font-bold capitalize">Best Free Games Online</h2>
                <p className="leading-8 font-medium capitalize">
                  Explore games from thousands of single and multiplayer simulator and arcade games. Choose from categories: action, racing, running, sports, cricket, classic, and relaxing games.
                </p>
              </section>

              <section>
                <h2 className="text-xl lg:text-2xl mb-6 font-bold capitalize">Our Popular Games</h2>
                <p className="leading-8 font-medium capitalize">
                  Not sure where to start? Try one of our top-rated games:
                </p>
                <div className="px-10">
                  <ul className="list-disc text-base font-medium capitalize leading-8">
                    <li><Link to="/game/ludo-dash" title="Ludo Dash Game">Ludo Dash</Link></li>
                    <li><Link to="/game/fruit-chop" title="Fruit Chop Game">Fruit Chop</Link></li>
                    <li><Link to="/game/escape-run" title="Escape Run Game">Escape Run</Link></li>
                    <li><Link to="/game/save-your-pinky" title="Save Your Pinky Game">Save Your Pinky</Link></li>
                    <li><Link to="/game/happy-kittens-puzzle" title="Happy Kittens Puzzle Game">Happy Kittens Puzzle</Link></li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl lg:text-2xl mb-6 font-bold capitalize">
                  Play Anywhere, Anytime
                </h2>
                <p className="leading-8 font-medium capitalize">
                  The Game Zone games are accessible on desktop, tablet, and mobile devices, allowing you to enjoy gaming wherever you are—at school, at home, or on the go. From desktops and laptops to the latest smartphones and tablets, our platform ensures a smooth, engaging experience on any device.
                </p>
              </section>

              <section>
                <h2 className="text-xl lg:text-2xl mb-6 font-bold capitalize">
                  Why Choose The Game Zone?
                </h2>
                <div className="px-10">
                  <ul className="list-disc text-base font-medium capitalize leading-8">
                    <li>Thousands of games updated regularly</li>
                    <li>No downloads, no pop-ups, and no login required</li>
                    <li>Games for desktop, mobile, and tablet</li>
                    <li>Play your favorite games anytime, anywhere</li>
                  </ul>
                </div>
                <p className="leading-8 font-medium capitalize mt-4">
                  Join the The Game Zone community and experience a world of free online games like never before.
                </p>
              </section>

              <section>
                <h2 className="text-xl lg:text-2xl mb-6 font-bold capitalize">About gameszone</h2>
                <p className="leading-8 font-medium capitalize">
                  gameszone is a platform for free online fun games. All our games are instantly accessible—no downloads, logins, or interruptions. Safe and easy to use. Play solo or with friends; fun is guaranteed.
                </p>
                <div className="px-10">
                  <ul className="list-disc text-base font-medium capitalize leading-8">
                    <li><Link to="http://gameszone.com/" title="Most Popular Games">Most Popular Games</Link></li>
                    <li><Link to="http://gameszone.com/" title="Trending Games">Trending Games</Link></li>
                    <li><Link to="http://gameszone.com/" title="Featured Games">Featured Games</Link></li>
                    <li><Link to="http://gameszone.com/" title="Latest Games">Latest Games</Link></li>
                    <li><Link to="http://gameszone.com/" title="New Games">New Games</Link></li>
                    <li><Link to="http://gameszone.com/" title="Hot Games">Hot Games</Link></li>
                  </ul>
                </div>
              </section>

            </div>
          </div>
        </div>
      </div>
    </div >

  )
}

export default About